import "../pages/css/Main.css";
import { useState } from "react";
import { DocumentSearchIcon } from "@heroicons/react/outline";
import { TwitterCrawlerService } from "../services/AnalysisService";
import { SentimentAnalyzerService } from "../services/AnalysisService";
import MainLayout from "../layouts/MainLayout";
import SocialMediaAnalysis from "../components/SocialMediaAnalysis";

const SentimentConsoleAnalysisPage = () => {
  const [inputText, setInputText] = useState("");
  const [error, setError] = useState("");
  const [isLink, setIsLink] = useState("false");
  const [numTweets, setNumTweets] = useState(10);
  const [tweetData, setTweetData] = useState([]);
  const [showManual, setShowManual] = useState(false);
  const [processedData, setProcessedData] = useState([]);
  const [sentimentResults, setSentimentResults] = useState([]);

  const crawlTweets = async () => {
    if (inputText.trim() === "") {
      setError("Keyword or link cannot be empty");
      setTimeout(() => setError(""), 3000);
      return;
    }
    setError("Fetching tweets...");
    try {
      const result = await TwitterCrawlerService(isLink, numTweets, inputText);
      if (result) {
        setTweetData(result);
        const newProcessedData = result.map((tweet) => ({
          id: tweet.conversation_id_str,
          content: tweet.full_text,
        }));
        setProcessedData(newProcessedData);
        console.log(newProcessedData);
        setError("");
      } else {
        setError("Looks like we're experiencing trouble. Try refreshing!");
      }
    } catch (error) {
      setError(error.message);
    }
  };

  const navigateQueryHistory = () => {
    window.location.href = "/query-history";
  };

  const navigateToConsole = () => {
    window.location.href = "/";
  };

  const navigateToSocialMedia = () => {
    window.location.href = "/sentiment-analysis";
  };

  const analyzeSentiment = async () => {
    if (processedData.length === 0) {
      setError("No tweets to analyze. Please fetch tweets first.");
      setTimeout(() => setError(""), 3000);
      return;
    }
    setError("Analyzing sentiment...");
    try {
      const result = await SentimentAnalyzerService(processedData);
      if (result) {
        console.log("Sentiment analysis result:", result);
        setSentimentResults(result);
        setError("");
      } else {
        setError("Unable to analyze sentiment. Please try again later.");
      }
    } catch (error) {
      console.error("Error analyzing sentiment:", error);
      setError(
        "An error occurred while analyzing sentiment. Please try again."
      );
    }
  };

  return (
    <MainLayout>
      <div className="py-2 sm:px-4">
        <div className="mt-4 lg:px-12 sm:px-4 md:px-6">
          <div className="text-center">
            <div className="flex flex-col gap-2 title">
              <p
                style={{ fontFamily: "Red Hat Display" }}
                className="text-bold lg:text-2xl md:text-xl sm:text-xl"
              >
                Welcome to <span className="orange">CONSOLE-D</span>
              </p>
              <p
                style={{ fontFamily: "Red Hat Display" }}
                className="text-xl text-bold"
              >
                The dashboard to bring CONSOLE to your crisis communications.
              </p>
            </div>
            <div className="mt-4 subtitle lg:text-base lg:px-20 sm:px-4 md:px-6 sm:text-sm md:text-sm">
              <p>
                <i>
                  The{" "}
                  <b>
                    CONSOLE (Coherence, Orientation, Nuance, Support, Ongoing,
                    Leadership, Empathy) framework
                  </b>{" "}
                  by Tan et al. (2019) proposes a framework to help
                  organisations break bad news effectively to stakeholders
                  during crisis through social media. For more information about
                  the framework, please see:
                  <a
                    href="https://www.sciencedirect.com/science/article/abs/pii/S0363811117303697"
                    className="underline orange"
                  >
                    Breaking Bad News with CONSOLE
                  </a>
                </i>
              </p>
            </div>
          </div>

          <div className="flex flex-row justify-start gap-6 mt-12">
            <div className="flex flex-row justify-center gap-8 bg-white border-2 border-gray-100 rounded-lg choice lg:py-2 lg:px-4 lg:w-56 md:w-52 md:py-2 md:px-4 sm:w-44 sm:px-2 sm:py-2">
              <div
                className="relative"
                onMouseEnter={() => setShowManual(true)}
                onMouseLeave={() => setShowManual(false)}
              >
                <button
                  className="text-gray-300 cursor-pointer lg:text-base md:text-sm sm:text-xs"
                  onClick={navigateToConsole}
                >
                  Manual
                </button>
              </div>
              <button className="orange lg:text-base md:text-sm sm:text-xs">
                <b>Social Media</b>
              </button>
            </div>
            <div
              className="flex flex-row items-center gap-2 px-4 py-2 rounded-lg bg-light-orange"
              onClick={navigateQueryHistory}
            >
              <DocumentSearchIcon className="w-6 h-6 sm:h-4 sm:w-4 md:h-4 md:w-4 orange" />
              <button className="font-bold orange lg:text-base md:text-sm sm:text-xs">
                Query History
              </button>
            </div>
          </div>

          <SocialMediaAnalysis />
        </div>
      </div>
    </MainLayout>
  );
};

export default SentimentConsoleAnalysisPage;
